import {
  Drawer as DrawerMui,
  DrawerProps as DrawerPropsMui,
} from '@mui/material';

export type DrawerProps = DrawerPropsMui;

export function Drawer({ children, ...rest }: DrawerProps) {
  return <DrawerMui {...rest}>{children}</DrawerMui>;
}
